export const UPLOAD_ANALYTICS_EVENT_ID = "0020";
export const UPLOAD_CHUNK_CONCURRENCY = 3;

export function uploadPercent(value) {
  const percent = Number(value);
  if (!Number.isFinite(percent)) return 0;
  return Math.max(0, Math.min(100, Math.round(percent)));
}

export function analyticsFileType(file) {
  return file?.type || file?.name?.split(".").pop() || "";
}

export function createUploadId(prefix = "upload") {
  const safePrefix = String(prefix || "upload")
    .replace(/[^a-z0-9_-]/gi, "")
    .toLowerCase() || "upload";
  const random =
    globalThis.crypto?.randomUUID?.() ||
    `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  return `${safePrefix}_${random}`;
}

export function uploadFailureDetail(
  error,
  fallbackStage = "unknown",
  fallbackReason = "unknown",
) {
  return {
    uploadStage: error?.uploadStage || fallbackStage || "unknown",
    failReason: error?.failReason || fallbackReason || "unknown",
    fileUrl: error?.fileUrl || "",
  };
}

export function uploadStatusPayload({
  modelType = "",
  file = null,
  fileUrl = "",
  status = "start",
  source = "upload",
  mediaDuration = 0,
  uploadStage = "",
  failReason = "",
  uploadId = "",
} = {}) {
  return {
    type: "upload",
    upload_id: uploadId,
    model_type: modelType,
    file_type: analyticsFileType(file),
    file_url: fileUrl,
    file_size: file?.size || 0,
    status,
    source,
    media_duration: mediaDuration || 0,
    upload_stage: uploadStage,
    fail_reason: failReason,
  };
}

export function createNoUrlUploadError(message, fileUrl = "") {
  const error = new Error(message);
  error.uploadStage = "resolve_url";
  error.failReason = "no_url";
  error.fileUrl = fileUrl || "";
  return error;
}
